import { Injectable } from '@angular/core';
import { HttpRestService } from '@core/services/http-rest.service';
import { PortalDeterminationService } from '@core/services/portal-determination.service';
import { ApplicationEligibility } from '@features/application-eligibility/application-eligibility.typing';

@Injectable({ providedIn: 'root' })
export class CopyApplicationResources {

  constructor (
    private http: HttpRestService,
    private portal: PortalDeterminationService
  ) { }

  copyApplication (
    applicationId: number,
    clientId?: number // only required on applicant endpoint
  ): Promise<ApplicationEligibility.CopyApplicationResponse> {
    const endpoint = this.portal.isApply ?
      'api/portal/applications/CopyApplication' :
      'api/manager/applications/CopyApplication';

    return this.http.post(endpoint, {
      applicationId,
      clientId
    });
  }
}
